import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDoor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"door, login, logout"} maskId="square-filled-radius-0-stroke-1-IconDoor"><path fillRule="evenodd" clipRule="evenodd" d="M4 2H20V21H22V22H2V21H4V2ZM7 12H9V13H7V12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconDoor;
